import React, { useState } from 'react';
import { Button } from './Button';
import { ArrowRight, CheckCircle2, Sparkles } from 'lucide-react';
import { useModal } from './ModalContext';
export const CallToAction = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const {
    openSignupModal,
    openJoinPilotModal
  } = useModal();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    // Reset form after 3 seconds
    setTimeout(() => {
      setIsSubmitted(false);
    }, 3000);
  };
  return <section id="cta" className="w-full bg-white py-section-mobile md:py-section-desktop relative overflow-hidden" data-id="element-35">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="max-w-6xl mx-auto" data-id="element-37">
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-20 items-center" data-id="element-38">
            <div className="lg:col-span-12" data-id="element-39"></div>
            <div className="lg:col-span-12" data-id="element-40">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3KFpKL4x8ZRHY6kZ6KEr1H/image.png" alt="Decorative divider with plant illustrations" className="w-full mx-auto mb-8" data-id="element-41" />
              <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-2xl shadow-glow p-4 md:p-8 lg:p-10 space-y-8 border border-primary-100 transition-all duration-300 hover:shadow-glow-hover backdrop-blur-sm lg:max-w-[80%] lg:mx-auto" data-id="element-42">
                <h2 className="text-h2-mobile md:text-h2-desktop font-serif font-normal text-cyan-800 mb-4 leading-tight text-center" data-id="element-43">
                  Building with the best coaches in the country
                </h2>
                <div className="space-y-6 md:space-y-8 max-w-[80%] mx-auto" data-id="element-44">
                  <p className="text-base font-medium md:text-lg text-gray-600 leading-relaxed text-center" data-id="element-45">
                    Join our early pilot network to shape what coaching can look
                    like when tools actually work for you.
                  </p>
                  <p className="text-base md:text-lg text-gray-600 leading-relaxed text-center" data-id="element-46">
                    Whether you're supporting 6 teachers or 60, Nisa is here to
                    make your day-to-day more intentional, less overwhelming,
                    and a lot more impactful.
                  </p>
                </div>
                <div className="space-y-6" data-id="element-47">
                  {isSubmitted ? <div className="text-center py-8" data-id="element-48">
                      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 text-green-600 mb-4" data-id="element-49">
                        <Sparkles className="w-8 h-8" data-id="element-50" />
                      </div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-51">
                        Thanks for joining!
                      </h3>
                      <p className="text-base text-gray-600 leading-relaxed" data-id="element-52">
                        We'll be in touch soon.
                      </p>
                    </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-53">
                      <div data-id="element-54"></div>
                      <div className="flex justify-center" data-id="element-55">
                        <div className="transform scale-110" data-id="element-56">
                          <a href="https://app.nisa.coach/pilot-program" data-id="element-57">
                            <Button type="button" size="lg" data-id="element-58">
                              Join the Nisa pilot
                              <ArrowRight className="w-5 h-5 ml-2" data-id="element-59" />
                            </Button>
                          </a>
                        </div>
                      </div>
                    </form>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};